/**
 * @fileoverview Theme Constants
 * @description Alaska Airlines brand colors and theme values
 */

// Alaska Airlines Brand Colors
export const COLORS = {
  // Primary Alaska Airlines Colors
  primary: {
    navy: '#01426A',      // Alaska Navy Blue
    darkNavy: '#002F5F',  // Darker Navy
    teal: '#0097A9',      // Alaska Teal
    lightTeal: '#00B4D2', // Light Teal
  },
  
  // Accent Colors
  accent: {
    orange: '#FF6B35',
    yellow: '#FFB81C',
    green: '#00AF66',
    red: '#E31837',
  },
  
  // Neutral Colors
  neutral: {
    white: '#FFFFFF',
    lightGray: '#F5F7FA',
    gray: '#E5E7EB',
    mediumGray: '#9CA3AF',
    darkGray: '#4B5563',
    charcoal: '#1F2937',
    black: '#111827',
  },
  
  // Semantic Colors
  semantic: {
    success: '#00AF66',
    warning: '#FFB81C',
    error: '#E31837',
    info: '#0097A9',
  }
};

export const GRADIENTS = {
  primary: `linear-gradient(135deg, ${COLORS.primary.navy} 0%, ${COLORS.primary.teal} 100%)`,
  secondary: `linear-gradient(135deg, ${COLORS.primary.darkNavy} 0%, ${COLORS.primary.navy} 100%)`,
  subtle: `linear-gradient(to bottom, ${COLORS.neutral.white} 0%, ${COLORS.neutral.lightGray} 100%)`,
};

export const SHADOWS = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};
